// Module
var code = `<!--<section class="page-hero page-item page-item&#45;&#45;hero">
  <div class="callout hero-content">
    <div class="gradient-wrapper">
      <h1>{{calloutTitle}}</h1>
      <p>{{calloutDesc}}</p>
    </div>
  </div>

  <figure class="bg-image hero-media">
    <img src="{{imgUrl}}" alt="{{alt}}" />
  </figure>
</section>-->


<!--
<article class="page-item page-item&#45;&#45;hero full-bleed1">
  <img class="hero-media" src="{{imgUrl}}" alt="">
  <div class="hero-content">
    <h1>{{calloutTitle}}</h1>
    <p>{{calloutDesc}}</p>
    <div class="actions"><button class="btn">Learn more</button></div>
  </div>
</article>
-->
<section class="page-body default-content">
  <div class="page-body-header">
    <h2>{{title}}</h2>
    <p>{{desc}}</p>
  </div>
  <ul class="cards-container card-list" aria-label="cards"></ul>
</section>
`;
// Exports
module.exports = code;